export default {
  //====================================弹窗提示================================
  "去维护": "Go maintain",
  "我知道了": "I know",
  "微信": "WeChat",
  "支付宝": "Alipay",
  "银行卡": "Bank card",
  "平台对您的需求抽成比例为": "The platform takes a commission of your demand",
  "如果对此比例有疑问，请联系电话18811961666商讨或不要发布任何需求": "If there is any doubt about this ratio, please contact phone 18811961666 to discuss or do not post any demand",
  "我们注意到您目前还未维护以下收款方式（": "We note that you are not currently maintaining the following payment method (",
  "）, 请在交易前维护好收款方式以获得交易利润": "), Please maintain the payment method before the transaction to obtain transaction profit",
  //====================================素材库================================
  "素材库": "Material library",
  "新建": "Add",
  "新建文件夹": "New folder",
  "返回上一级": "Return to the previous",
  "商品文件夹": "Product folder",
  "重命名": "Rename",
  "输入新名称": "Enter a new name",
  "输入文件夹名": "Enter the folder name",
  "素材库使用协议": "Material Library Usage Agreement",
  "我同意": "I agree",
  "裁剪图片": "Crop image",

  //====================================消息================================
  "我的消息": "My message",
  "消息中心": "Message center",
  "需求方收件箱": "Demand side inbox",
  "供应方收件箱": "Supplier Inbox",
  "协调方收件箱": "Coordinator Inbox",
  "标为已读": "Mark as read",
  "全部标为已读": "All marked as read",
  "标签": "Label",
  //====================================需求方--结账================================
  "结账": "Buy now",
  "选择收货地址": "Select shipping address",
  "选择付款方式": "Select a payment method",
  "微信支付": "Weixin Pay",
  "中国的微信支付，需要使用微信APP扫码支付": "Weixin Pay in China requires the use of WeChat APP to scan the code for payment",
  "支付宝支付": "Alipay payment",
  "中国的支付宝支付，需要使用支付宝APP扫码支付": "Alipay payment in China requires the use of Alipay APP to scan code for payment",
  "银行卡中国方支付": "Bank card payment by China",
  "请选择一个丝迈官方的中国银行卡，并往里面汇款，汇款时请在附言或备注栏注明订单号，需求ID或费用说明等关键信息以供平台快速结算，需要等待平台对转账金额确认后，订单才能继续": "Please select an official Simai China bank card and remit money to it. When remitting money, please indicate key information such as the order number, requirement ID or fee description in the postscript or remarks column for quick settlement by the platform. You need to wait for the platform to confirm the transfer amount before the order can be continued",
  "个人银行卡转账": "Personal bank card transfer",
  "企业银行卡转账": "Corporate bank card transfer",
  "银行卡国际方支付": "Bank Card International Party Payment",
  "请选择一个丝迈官方的国际银行卡，并往里面汇款，汇款时请在附言或备注栏注明订单号，需求ID或费用说明等关键信息以供平台快速结算，需要等待平台对转账金额确认后，订单才能继续": "Please select an official Simai international bank card and transfer money to it. When transferring money, please indicate key information such as the order number, requirement ID or fee description in the postscript or remarks column for quick settlement by the platform. You need to wait for the platform to confirm the transfer amount before the order can be continued",
  "在你需要协调或担保时，请选择平台提供的协调服务，平台将为您配备专业的协调员，帮助您解决交易中的问题。在没有选择协调服务的交易下所造成的损失，将由需求方自己承担": "When you need coordination or guarantee, please choose the coordination service provided by the platform. The platform will equip you with a professional coordinator to help you solve problems in trading. Losses caused under transactions that do not choose to coordinate services will be borne by the demanding party itself",
  "商品与运输": "Goods and transportation",
  "订单摘要": "Order summary",
  "项目": "Project",
  "订单总额": "Order total",
  "如果您选择了协调服务，在后续可能还会支付给协调员一定的协调费和商品运费，具体的协调费用与运费请与协调员在后续约定金额": "If you choose the coordination service, you may also pay the coordinator a certain coordination fee and commodity freight in the future. Please agree with the coordinator on the specific coordination fee and freight in the future.",
  "我已付款": "already paid",
  //====================================商品卡片================================
  "过去一个月有": "The past month",
  "顾客购买": "customers purchased",
  "元": "Yuan",
  "已售": "Sold",
  "物流": "Logistics",
  "发货地": "Deliverey address",
  "配送到": "Delivered to",
  "数量": "Quantity",
  "产品说明": "Product description",
  "顾客评论": "Customer reviews",
  "条全球评论": "Global reviews",
  "星": " star",
  "查看商店": "Visit the store",
  "商品种类": "Types of goods",
  "开始项目": "start the project",
  "天完成项目": "days to complete the project",
  "点击查看完成视图": "Click to view the completed view",
  "没有详细信息": "No details",
  //====================================订单追踪================================
  "订单编号": "Order number",
  "规格": "Specifications",
  "结算金额": "Settlement amount",
  "运至": "Shipped to",
  "收货人": "Consignee",
  "购买日期": "Purchase date",
  "发货时间": "Delivery time",
  "订单当前状态": "Current status of order",
  "发货人": "Consignor",
  "物流单号": "Logistics order number",
  "历史记录": "History",
  //====================================收货地址/发货地址================================
  "默认": "Default",
  "添加一个新地址": "Add a new address",
  "输入新的收货地址": "Enter a new shipping address",
  "输入新的发货地址": "Enter a new shipping address",
  "添加新地址": "Add a new address",
  "国家/地区": "Country/Region",
  "请选择国家": "Please select country",
  "全名（名和姓）": "Full name (first and last name)",
  "请输入您的名称": "Please enter your name",
  "电话号码注意添加区号": "Telephone number Note Add area code",
  "城市，区，街道，详细地址等": "City, district, street, detailed address, etc.",
  "邮政区码": "zip code",
  "请输入邮政区码": "Please enter the postal code",
  "将此地址设为默认地址": "Set this address as the default address",
  "使用这个地址": "Use this address",
  "输入新的": "Enter a new",
  "输入修改后的": "Enter the modified",
  "修改地址": "Modify the address",
  //====================================协调方================================
  "货品订单": "Goods orders",
  "货品协调订单": "Goods coordination order",
  "需求协调订单": "Demand coordination orders",
  "需求方账号名称": "Demand side account name",
  "协调费报价": "Coordination fee quote",
  "开具协调证明": "Issue coordination certificate",
  "协调证明标题": "Coordination certificate title",
  "运费报价": "Freight quote",
  "需求订单": "Demand orders",
  "账户设置": "Account settings",
  "协调费金额": "Coordination fee amount",
  "请输入协调费金额": "Please enter the coordination fee amount",
  "协调员收货地址": "Coordinator Shipping Address",
  "已确认收到货物": "Received goods confirmed",


  //====================================供应方-收款方式绑定================================
  "微信支付收款绑定": "Weixin Pay collection binding",
  "已绑定": "already bound",
  "未绑定": "unbound",
  "更改": "change",
  "支付宝支付收款绑定": "Alipay payment collection binding",
  "绑定": "Binding",
  "中国收款银行卡绑定": "Binding of collecting bank card in China",
  "添加": "Added",
  "公司名称": "Company name",
  "开户行": "Opening bank",
  "银行账号": "Bank account number",
  "行号": "Bank line number",
  "备注": "remarks",
  // "单笔限额": "Single limit",
  "万": "million",
  "账户名": "Account name",
  "国际收款银行卡绑定": "International collection bank card binding",
  "收款人姓名": "Payee name",
  // "收款行所在国家（地区）": "Country (region) of receiving bank",
  "收款币种": "Receipt currency",
  "SWIFT代码": "SWIFTcode",
  "收款人账号": "Payee account number",
  "IBAN号": "IBAN number",
  "收款行标识": "Receiving bank ID",
  "请输入开户支行行号": "Please enter the bank branch line number",
  // "本地清算号": "Local clearing number",
  "收款行全称": "Full name of receiving bank",
  "收款行地址": "Paying bank address",
  "设为默认": "Set as default",
  "收款银行卡": "Receiving bank card",
  "银行卡类型": "Bank card type",
  "个人银行账户": "Personal bank account",
  "银行名称": "Bank name",
  "请输入银行名称": "Please enter bank name",
  "请输入账户名": "Please enter account name",
  "输入开户支行名称": "Enter the name of the branch that opens the account",
  "请输入银行账号": "Please enter bank account number",
  "请输入公司名称": "Please enter company name",
  "输入备注，不超过200字": "Enter comments, no more than 200 words",
  "请输入收款人姓名": "Please enter payee name",
  "收款行所在国家（地区）": "Country (region) of receiving bank",
  "请输入swift代码": "Please enter the swift code",
  "请输入IBAN号": "Please enter your IBAN number",
  "请输入收款行标识": "Please enter the collection bank ID",
  "请输入收款行全称": "Please enter the full name of the receiving bank",
  "请输入收款行地址": "Please enter the receiving bank address",
  "微信与支付宝收款，点击绑定，用微信或支付宝扫描对应二维码，扫码后出现success文字后即代表绑定成功，手动刷新次此页面查看是否已变更为“已绑定”状态。需求方的在线支付将在确认收货后，平台结算给供应方。":"For WeChat and Alipay payments, click \"Bind\", scan the corresponding QR code with WeChat or Alipay, and the text \"success\" will appear after scanning, indicating successful binding. Manually refresh this page to check if it has changed to \"Bound\" status. The demander's online payment will be settled by the platform to the supplier after confirmation of receipt.",

  //====================================供应方-店铺内商品分类================================
  "分类名称": "Classification name",
  "排序值": "Rank values",
  "添加时间": "Addition time",
  "修改": "Modify",
  "下级分类": "Sublevel classification",
  "下级分类名称": "Sublevel classification name",
  //====================================供应方-店铺信息修改================================
  "供应方商店头像": "Supply side shop avatar",
  "供应方商店主图": "Main map of supplier store",
  "商店banner图": "Store banner diagram",
  "商店标签": "Store tag",
  "发货地址": "Shipping address",
  "收货地址": "Delivery address",
  "店铺简介": "Store Introduction",
  "请输入店铺简介": "Please enter the store description",
  //====================================供应方-案例管理================================
  "案例id": "Case ID",
  "发布案例": "Release case",
  "个案例": "Cases",
  "上架中的案例": "Cases on the shelves",
  "已下架的案例": "Cases removed from shelves",
  "案例状态": "Case status",
  "案例名称": "Case name",
  "案例价格": "Case prices",
  "累计用时": "Cumulative time",
  "案例发生时间": "Time of case occurrence",
  "案例ID": "Case ID",
  "下架": "Removed",
  "案例类目": "Case Category",
  "请选择案例类目": "Please select a case category",
  "请输入标签名称后点击“添加”": "Please enter the label name and click “Add”",
  "案例主图": "Main picture of case",
  "案例简介": "Case introduction",
  "请输入案例简介": "Please enter the case brief",
  "案例详情": "Case details",
  "提交并立刻上架": "Submit and put it on the shelves immediately",
  "存入已下架": "Deposit has been removed",
  "案例轮播图": "Case carousel",
  "请输入案例名称": "Please enter the case name",
  "发布": "Released",
  "上架中": "On the shelves",
  "已下架": "Have been removed",
  //====================================供应方-订单管理================================
  "待供应商收货": "Waiting for supplier to receive goods",
  "退款/售后": "Refund/after-sales",
  "修改订单价格": "Modify order price",
  "关闭订单": "Close orders",
  "选择协调服务": "Select Coordination Services",
  "查看收货地址": "Check the shipping address",
  "填写物流信息": "Fill in logistics information",
  "运费确认": "Freight confirmation",
  "确认退款": "Recognises a refund",
  "发货": "Delivery",
  "物流公司": "Logistics company",
  "请输入发货物流公司": "Please enter shipping logistics company",
  "物流方式": "Logistics methods",
  "请输入发货物流方式": "Please enter the shipping logistics method",
  "图片": "picture",
  "确认": "confirm",
  "订单改价金额": "Order Price Change Amount",
  "订单结算金额": "Order settlement amount",
  "请输入您更改后的订单结算金额": "Please enter your changed order settlement amount",

  //====================================供应方-我的投标================================
  "个投标": "bids",
  "需求信息": "Requirement information",
  "中标信息": "Winning bid information",
  "付款信息": "Payment information",
  "协调员": "Coordinator",
  "需求发布时间": "Requirement release time",
  "需求发布金额": "Requirement post Amount",
  "个供应商参与": "suppliers participated",
  "中标供应方": "Winning supplier",
  "合同金额": "Contract amount",
  "查看详情": "View details",
  "订单选择的协调服务": "Coordination service for order selection",
  "确认终止合作": "Confirm termination of cooperation",
  "终止合作": "termination of cooperation",
  "验收资料上传": "Upload acceptance data",
  "签署合同": "sign the contract",
  "合同金额报价": "Contract amount quotation",
  "合同报价": "contract offer",
  "请输入合同金额": "Please enter the contract amount",
  "输入合同总金额": "Enter total contract amount",
  "合同金额确认": "Contract amount confirmation",
  "确认合作": "Confirm cooperation",
  "合同": "contract",
  "我的中标": "My winning bid",
  //====================================参与投标弹框================================
  "参与投标/投聘": "Participate in bidding/Applying for a job",
  "请上传相关投标文件": "Please upload relevant bidding documents",
  "序号": "Serial number",
  "附件": "Annex",
  "返回结果": "Return results",
  "附件下载": "Attachment download",
  "留言板": "Message board",
  //====================================供应方-需求卡片================================
  "需求ID": "Requirement ID",
  "招标中/招聘中": "Bidding/Recruitment",
  "参与投标数量": "Number of bidding participants",
  "需求完成时间": "Demand completion time",
  //====================================搜索结果================================
  "产品": "PRODUCTS",
  "需求": "Requirement",
  "结果": "Results",
  "查看每个商品页面以了解其他购买选项，价格和其他详情可能因商品尺寸和颜色而异": "Check each product page for additional purchase options, prices and other details may vary based on product size and color",
  "查看每个供应商的商店来了解他们的其他商品": "Check each supplier's store to learn about their other products",
  "查看每个案例页面并发现更多供应商相关案例": "View each case page and discover more vendor-related cases",
  "共超过": "More than",
  "服务": "SERVICES",
  "价格：从低到高": "Price: from low to high",
  "价格：从高到低": "Price: from high to low",
  "销量：从低到高": "Sales: From low to high",
  "销量：从高到低": "Sales: From high to low",
  "评分：从低到高": "Rating: From low to high",
  "最新案例": "Latest case",
  "条搜索结果": "search results",
  "最新商品": "Latest product",
  "综合排序(随机排序)": "Comprehensive sorting (random sorting)",
  "需求状态": "Requirement state",
  "排序方式": "Sort by",
  "查看每个需求以了解其他信息": "Review each requirement for additional information",
  //====================================发布需求================================
  "需求名称": "Requirement name",
  "请输入需求名称": "Please enter the requirement name",
  "需求类目": "Requirement  category",
  "招标产品": "Tender products",
  "招聘": "Recruitment",
  "请选择需求类目": "Please select a Requirement category",
  "需求总金额": "Total amount required",
  "需求总金额报价": "Total amount required quote",
  "输入需求总金额": "Enter the total amount required",
  "请输入需求总金额": "Please enter the total amount required",
  "查看今日汇率": "Check today's exchange rates",
  "协调服务": "Coordination services",
  "不选择协调服务": "Do not choose coordination services",
  // "请选择协调服务": "Please select a coordination service",
  "协调服务说明": "Coordination service description",
  "招标时间段": "Tender period",
  "比选结果公示时间必须在招标结束时间之后": "The publicity time for the comparison results must be after the bidding end time",
  "至": "to",
  "比选结果公示时间": "Announcement time for comparison results",
  "选择日期": "Select date",
  "定金": "Deposit",
  "尾款": "Final payment",
  "附件上传": "Attachment uploading",
  "上传": "Upload",
  "只能上传图片文件": "Only image files can be uploaded",
  "需求主图": "Main picture of Requirement",
  "投标要求": "Requirements for bidding",
  "请输入投标要求": "Please enter your bidding requirements",
  "需求介绍": "Requirements introduction",
  "需求轮播图": "Requirements carousel",
  "最多上传 6 张": "Upload up to 6 photos",
  "请输入内容": "Please enter content",
  "百分比": "percentage",
  "金额": "amount",
  "请选择招标时间段": "Please select the bidding period",
  // "请选择招标截止日期": "Please select the bidding deadline",
  "请选择定金支付方式": "Please select the deposit payment method",
  "请选择比选结果公示日期": "Please select the date for the comparison results to be announced",
  "请输入定金": "Please enter a deposit",

  //====================================我的购物================================
  "全部": "All",
  "待供应方选择协调员": "Coordinator to be selected by supplier",
  "待协调员接单": "Waiting for coordinator to receive orders",
  "待供应商发货": "Waiting for supplier delivery",
  "个订单": "orders",
  "最近": "recent",
  "天": "days",
  "刷新": "Refresh",
  "请选择": "Please select",
  "商品名称": "Product name",
  "商品ID": "Commodity ID",
  "供应方账号名称": "Supplier Account Name",
  "协调员账号名称": "Coordinator account name",
  "付款时间": "Payment time",
  "交易人员信息": "Trader Information",
  "商品信息": "Commodity information",
  "评价": "Evaluation",
  "分值": "Score",
  "评价内容": "Evaluation content",
  "删除评价": "Deleting reviews",
  "确认删除评价": "Confirm delete evaluation",
  "协调证明": "Coordination proof",
  "暂无协调证明": "No coordination certificate",
  "暂无图片": "No image",
  "订单状态": "Order status",
  "系统提示": "System notification",
  "操作": "Operation",
  "订单号": "Order number",
  "创建时间": "Creation time",
  "需求方协调订单": "Demand-side coordinates orders",
  "需求方名称": "Name of demander",
  "协调员名称": "Coordinator name",
  "查看": "View",
  "待管理端确认银行卡收款": "Pending confirmation of bank card collection by management end",
  "取消订单": "Cancel the order",
  "订单追踪": "Order tracking",
  "确认收货": "Confirm the receipt",
  "退款": "Refund",
  "支付订单": "Payment order",
  "确认取消订单": "Confirm cancellation of order",
  "取消": "Cancel",
  "确定": "Determine",
  "待供应方选择协调服务": "Waiting for suppliers to select and coordinate services",
  "待协调员接单(后台指派协调员)": "Waiting for the coordinator to receive the order (the coordinator is assigned in the background)",
  "待供应方收货(协调员发现商品质量不合格,退回给供应方)": "Waiting for the supplier to receive the goods (the coordinator finds that the quality of the goods is substandard and returns them to the supplier)",
  "供应方协调订单":"Supplier coordinates orders",
  "是否产生运费":"Whether freight charges are incurred",
  //====================================需求方================================
  "认证名称不能为空": "Certification name cannot be empty",
  "请上传证件图片": "Please upload your ID picture",
  "请上传合同章/签章": "Please upload the contract seal/signature",
  "需求方认证请上传合同章/签章": "Please upload the contract seal/signature",
  "需求方认证": "Demand-side certification",
  "需求方认证名称": "Demand-side certification name",
  "需求类型": "Requirement type",
  "是否公开": "Visibility",
  "公开": "Public",
  "私密": "Private",
  "请选择是否公开": "Please select visibility",
  "您希望在平台解决什么类型的需求": "What types of needs do you want to address on the platform",
  //====================================需求方--我的需求================================
  "比选中": "Comparing",
  "待供应方确认": "Pending confirmation by the supplier",
  "待平台确认": "Pending platform confirmation",
  "合同签订中": "Contract is being signed",
  "进行中": "Ongoing",
  "已完成": "Has completed",
  "已关闭": "Has been closed",
  "中标供应方名称": "Name of winning supplier",
  "联系人": "contact",
  "协调费确认": "Coordination fee confirmation",
  "协调费": "Coordination fee",
  "协调费合计": "Total coordination fee",
  "协调费报价中": "Coordination fee being quoted",
  "请输入您拒绝的原因": "Please enter the reason for your refusal",
  "输入拒绝原因": "Enter reason for rejection",
  "拒绝": "Refused",
  "付款": "Payment",
  "关闭需求": "Shut-off requirement",
  "确认关闭需求": "Confirm closure requirements",
  "投标供应方": "Bid supplier",
  "重新报价": "Re-quotes",
  "支付定金": "pay the deposit",
  "验收资料下载": "Acceptance data download",
  "支付尾款": "pay the final payment",
  "请选择支付方式": "Please select payment method",
  "个供应方投标": "suppliers bid",
  "参与投标时间": "Time to participate in bidding",
  "供应方主页": "Supplier Homepage",
  "下载投标文件": "Download bid documents",
  "中标": "winning bid",
  "是否确认": "are you sure",
  "供应方为最终中标供应方，并以如下价格意向进行合作": "The supplier is the final winning supplier, and cooperates with the following price intentions",
  "自行上传合同": "Upload your own contract",
  "使用平台合同": "Use of platform contract",
  "仅支持pdf格式": "Only pdf format is supported",
  "为保障您的权益，您支付的定金将由迈丝官方保管，直至完成后结算给供应方": "In order to protect your rights and interests, the deposit you pay will be officially kept by Mess until it is settled to the supplier after completion",
  "需求价格": "Requirement price",
  "银行卡支付": "Bank card payment",
  "平台合同预览": "Platform contract preview",
  "请选择付款方式": "Please select a payment method",
  "上传合同": "Upload contract",
  "重置": "Reset",
  "确认签署": "Confirmation of signature",
  "下载": "Download",
  "运费": "Freight",
  "商品金额": "Amount of goods",
  "退款原因": "Reason for the refund",

  //====================================协调员================================
  "成为协调员": "Become coordinator",
  "姓名": "Name",
  "请输入您的姓名": "Please enter your name",
  "上传个人证件证明": "Upload personal ID certificate",
  "签章": "Signature",
  "上传PNG无背景格式的个人签章": "Upload PNG personal signature in backgroundless format",
  //====================================供应方认证================================
  "成为供应方": "Become a supplier",
  "供应方认证名称": "Supplier Certification Name",
  "请输入个人或企业名称": "Please enter your personal or business name",
  "请输入": "Please enter",
  "供应行业类目": "Supply Industry Category",
  "请选择供应行业类目": "Please select a supply industry category",
  "证件认证": "Certificate certification",
  "上传个人证件证明 或 企业营业执照": "Upload personal ID certificate or business license",
  "擅长技能或供应货品类型": "Expertise in skills or types of goods supplied",
  "合同章/签章": "Contract seal/signature",
  "上传PNG无背景格式的企业合同章签章或个人签章": "Upload PNG corporate contract seal or personal signature without background format",
  "供应方名称": "Name of supplier",
  "顾客将会通过供应方名称搜索到你的店铺": "Customers will search for your store by the supplier name",
  "提交资料": "submit information",
  "点击": "click",
  "即代表您已阅读并同意我们的": "This means that you have read and agreed to our",
  "需求方服务协议": "Demand-side service agreement",
  "协调方服务协议": "Coordinator Service Agreement",
  "供应方服务协议": "Supplier Service Agreement",
  "消费者保障服务协议": "Consumer Protection Service Agreement",
  "丝迈网商支付服务协议": "SilkMiles Online Merchant Payment Service Agreement",
  //====================================忘记密码================================
  "忘记密码": "Forgot Password",
  "手机号": "Mobile phone number",
  "验证码": "Captcha",
  "获取验证码": "Get the Captcha",
  "密码": "Password",
  "新密码": "New password",
  "继续": "Continue",
  //====================================创建账户================================
  "创建账户": "Create an account",
  "已有账户": "Existing account",
  "请输入手机号": "Please enter your mobile number",
  "请输入验证码": "Please enter Captcha",
  "请输入密码": "please enter the password",
  "请输入账号名称": "Please enter account name",
  "请输入姓氏": "Last name",
  "请输入名": "Please enter your first name",
  "请选择性别": "Please select gender",
  "请输入账号所属区": "Please enter the area to which the account belongs",
  "请输入国家": "Search for countries",
  "请输入城市": "Please enter a city",
  "请输入邮政编码": "Please enter a postal code",
  "请输入邮箱地址": "Please enter your email address",
  "请输入地址": "Please enter the address",
  "请输入微信号": "Please enter your WeChat account",
  "请输入传真": "Please enter the fax",
  "请输入QQ号": "Please enter your QQ number",
  "更改邮箱": "Change email",
  // "点击创建账户即代表您已阅读并同意我们的 用户协议，用户隐私协议，法律声明，丝迈平台服务协议。": "By clicking Create Account, you will mean that you have read and agreed to our User Agreement, User Privacy Agreement, Legal Statement, and Simai Platform Service Agreement。",
  //====================================登录/注册================================
  "请输入邮箱地址或手机号": "Please enter your email address or mobile number",
  "以“需求方”的身份登录": "Log in as the “demander”",
  "以“供应方”的身份登录": "Log in as “supplier”",
  "以“协调员”的身份登录": "Log in as “Coordinator”",
  "登录操作即表示您已阅读并同意我们的": "By logging in, you mean that you have read and agreed to our",
  // "用户协议， 用户隐私协议，法律声明，丝迈平台服务协议": "User Agreement, User Privacy Agreement, Legal Statement, Simai Platform Service Agreement",
  "丝迈交易平台新用户": "New users of SilkMiles Platform",
  "创建您的丝迈交易平台账户": "Create your SilkMiles Platform account",
  "当前登录身份资料审核中": "Currently under review for login identity data",
  "账号不能为空": "Account cannot be empty",
  "密码不能为空": "Password cannot be empty",
  "请选择登录身份": "Please select login identity",
  "登录失败": "login failed",
  "登录中": "Registry",
  "关闭": "close",
  "您的姓名": "Your name",
  "电话号码": "Phone number",
  "电子邮件": "Email",
  "账号所属区": "Account area",
  "再次输入密码": "Type your password again",
  "验证手机号码": "Verify email",
  "用户协议": "User Agreement",
  "用户隐私协议": "User Privacy Agreement",
  "法律声明": "legal notices",
  "丝迈平台服务协议": "SilkMiles Platform Service Agreement",
  "已拥有账户": "Existing account",
  "无法上传更多图片": "Unable to upload more pictures",
  "验证码已发送至您的手机号码": "Captcha has been sent to your mobile number",
  "重新发送验证码": "Resend Captcha",
  "请选择您所生活或主要提供服务的区域，这非常重要": "It is important to choose the area where you live or where you mainly serve",
  "密码至少包含八个字符，其中至少包含一个数字，并 包含 小写字母、大写字母和特殊字符": "The password contains at least eight characters, including at least one number, and contains lower case letters, upper case letters, and special characters",
  "为了您的安全，我们已将代码发送到您的邮箱": "For your safety, we have sent the code to your email",
  "为了您的安全，我们将通过代码发送到您的邮箱": "For your safety, we will send it to your email via code",
  "发送验证码": "Send Captcha",
  "返回": "Return",
  "两次密码输入不一致": "Two password inputs are inconsistent",
  "请确认密码": "Please confirm your password",
  "提交代码": "Submit code",
  "请输入有效的电子邮件": "Please enter a valid email",
  "请输入您的名字": "Please enter your first name",
  "请输入有效的手机号码": "Please enter a valid mobile number",
  "输入密码": "Enter the password",
  "我们找不到具有该电子邮件地址或手机号码的账号": "We cannot find an account with that email address or mobile number",
  "密码输入错误": "Password entered incorrectly",
  "当前身份申请未通过，未通过原因": "The current identity application was not approved, reason for failure:",
  "当前账号不是“供应方”，您希望成为“供应方”吗？": "The current account is not a “supplier”. Do you want to become a “supplier”?",
  "当前账号不是“协调员”，您希望成为“协调员”吗？": "Your current account is not a “Coordinator”. Do you want to become a “Coordinator”?",
  "输入验证码": "Enter Captcha",
  "密码帮助": "Forget your password?",
  "输入与您的 丝迈交易平台 账户相关联的邮箱": "Enter the email number associated with your SilkMiles Platform account",
  "请输入手机号码": "Please enter your mobile number",
  "输入新密码": "Enter the new password",
  "提交新密码": "Submit a new password",
  "超管登录": "Hypertube login",
  "超管账号": "Hypermanage account",
  "超管密码": "Hypertube password",
  //====================================顶部导航================================
  "丝迈交易平台": "SilkMiles",
  "中文": "Chinese",
  "英文": "English",
  "中国区": "China Zone",
  "国际区": "International Zone",
  "搜索": "Search",
  "商品": "Products",
  "供应商": "Suppliers",
  "案例": "Case studies",
  "发布需求": "Requirements",
  "登录": "login",
  "注册": "registered",
  "或": "or",
  "我的订单统计": "My order statistics",
  "需求订单统计": "Requirement order statistics",
  "订单状态统计": "Order status statistics",
  "查看更多": "view more",
  "待需求方付款": "Pending payment from the demander",
  "协调费协商中": "Coordination fee negotiation",
  "拒绝原因": "Reject cause",
  "待供应方发货": "Pending shipment from the supplier",
  "待协调员收货": "Waiting for coordinator to receive goods",
  "协调员已收货": "Coordinator received the goods",
  "运费协商中": "Freight negotiation",
  "待需求方收货": "Waiting for the demander to receive the goods",
  "待需求方评价": "Pending evaluation by the demand side",
  "我的账户": "My account",
  "我的购物": "My shopping",
  "我的需求": "My requirement",
  "个人资料": "Personal data",
  "我的认证": "My certification",
  "修改密码": "Change the password",
  "退出": "Exit",
  "切换身份": "Switch identities",
  "已认证": "Authenticated",
  "已拒绝": "Rejected",
  "审核中": "Reviewing",
  "未认证": "Unauthenticated",
  "立即登录": "sign in now",
  "新客户": "new customers",
  "免费注册": "Free registration",
  "我的投标": "My bid",
  "中标订单": "winning order",
  "请输入留言": "please enter the message",
  "回复": "Reply",
  "发布人": "Posted by",
  "发送": "Sent",
  "发送成功": "Sent successfully",
  "不需要协调服务": "No coordinated services required",
  "操作失败": "Operation failed",

  //====================================我的认证================================
  "重新认证": "Re-authentication",
  "性别": "Gender",
  "地址": "Address",
  "联系方式": "Contact information",
  "名称": "Name",
  "国家": "Countries",
  "城市": "City",
  "邮箱": "Email",
  "邮政编码": "Postal code",
  "保存": "Save",
  "操作成功": "Operation is successful",
  "复制链接成功": "Link copied successfully",
  "复制失败": "Copy failed",
  "请先使用供应方身份登录": "Please log in as a supplier first",
  "当前登录账号是以{role}身份登录的，需要用供应方身份登录": "The current account is logged in as {role}. Please log in as a supplier.",
  "当前登录账号是以{role}身份登录的，需要切换到供应方身份": "The current account is logged in as {role}. Please switch to supplier identity.",
  "提示": "Notice",
  "游客": "Guest",
  "超管": "Admin",
  "注册成功": "Registration is successful",
  "上传签章图片只能是 PNG 格式": "Upload signature images can only be in PNG format",
  "上传失败": "Upload failed",
  "上传文件必须是图片": "Upload files must be pictures",
  "文件上传成功": "File uploaded successfully",
  //====================================我的店铺================================
  "我的店铺": "My shop",
  "ID": "ID",
  "耐克丝迈官方店": "耐克丝迈官方店",
  "耐克（中国）股份有限公司": "耐克（中国）股份有限公司",
  "今日新增订单": "New orders today",
  "今日订单收益": "Today's order revenue",
  "过去一个月订单": "Orders for the past month",
  "过去一个月订单收益": "Order revenue for the past month",
  "中国区店铺": "china shop",
  "营业中": "Currently open",
  "已禁用": "Disabled",
  "进入店铺": "Enter the store",
  "店铺标签": "Shop label",
  "默认物流配送方式": "Default logistics distribution method",
  "默认收货地址": "Default Shipping Address",
  "默认发货地址": "Default shipping address",
  "商品管理": "Goods management",
  "案例管理": "Cases management",
  "店铺信息修改": "Store information modification",
  "收款方式绑定": "Collection method binding",
  "店铺内商品分类": "Product classification in store",
  "店铺内案例分类": "Case classification in store",
  "订单管理": "Order management",
  "我的案例": "My cases",
  "需求方": "Demand side",
  "需求方/招标/招聘": "Demand side/Bidding/Recruitment",
  "供应方": "Supply side",
  "供应方/投标/投聘":"Supply side/Bid/Apply for",
  "协调方": "Coordinator",
  "商店类目": "Store Category",
  "个需求成功交易": "requirements were successfully traded",
  "查看商品": "View product",
  "查看案例": "View case",
  "所有商品分类": "All product categories",
  "所有案例分类": "All case categories",
  "搜索商品名称": "Search for product names",
  "所有商品": "All goods",
  "搜索案例名称": "Search case name",
  "所有案例": "All cases",
  //====================================我的店铺-商品管理================================
  "商品id": "Goods id",
  "发布商品": "Release goods",
  "出售中的商品": "Goods on sale",
  "出售中": "On sale",
  "已下架的商品": "Unsold goods ",
  "个商品": "Goods",
  "商品类型": "Supplies type",
  "商品标题": "Commodity titles",
  "商品SKU": "Goods SKU",
  "商品价格": "Commodity prices",
  "总库存": "Total inventory",
  "商品SKU编码": "Goods SKU code",
  "商品状态": "Goods status",
  "下架时间": "Removal time",
  "商品展示价": "Product display price",
  "展示原价": "Display original price",
  "编辑": "Edit",
  "上架": "Listed",
  "删除": "Delete",
  "添加规格": "Add specifications",
  "主规格": "Primary specification",
  "副规格": "Secondary specification",
  "库存不能小于0": "Inventory cannot be less than 0",
  "请添加销售属性": "Please add sales attributes",
  "请添加销售规格": "Please add sales specifications",
  "请输入商品标题": "Please enter the goods title",
  "商品类目": "Goods category",
  "请选择商品类目": "Please select a Goods category",
  "店铺内分类": "Classification within store",
  "请选择店铺内分类": "Please select a classification within the store",
  "商品属性": "Commodity attributes",
  "请输入商品的各项关键属性信息": "Please enter the key attribute information of the product",
  "销售属性": "Sales attribute",
  "销售规格": "Sales specifications",
  "售价": "Price",
  "请输入售价": "Please enter the selling price",
  "原价": "Original price",
  "请输入原价": "Please enter the original price",
  "库存": "Inventory",
  "请输入库存": "Please enter inventory",
  "SKU编码": "SKU code",
  "请输入SKU编码": "Please enterSKU code",
  "规格展示图": "Specification display chart",
  "请选择商品类型": "Please select product type",
  "请输入商品展示价": "Please enter the product display price",
  "商品原价": "Original price of the goods",
  "请输入商品原价": "Please enter the original price",
  "库存规则": "Inventory rules",
  "拍下减库存": "Auction to reduce inventory",
  "商品详情": "Product details",
  "详情": "Details",
  "禁用": "Disable",
  "热门评论": "Popular comments",
  "最新评论": "Latest comments",
  "来自全球的评论": "Comments from around the world",
  "有用": "useful",
  "感谢您的反馈": "Thanks for your feedback",
  //====================================商品详情================================
  "参观": "Visit ",
  "的商店": "'s store",

  //====================================底部================================
  '深红未来(深圳)科技有限公司':'DeepRed(ShenZhen)Technology Co., Ltd.',
  '苏ICP备2025171803号-1':'苏ICP备2025171803号-1',
  '深公网安备 33011002011859号':'深公网安备 33011002011859号',
  '请输入拒绝原因':'Please enter reason for rejection',
  '协调方收货地址':'Coordinator\'s Shipping Address',
  '需求方收货地址':'Demand side delivery address',
  '是否有物流':'Whether there is logistics',
  '退款确认':'Refund ascertainment',
  '请选择收货地址':'Please select the shipping address',
  '为保障您的权益，您支付的金额将会由深红官方保管，直至完成后结算给供应方':'In order to protect your rights and interests, the amount you pay will be kept by Crimson officials until it is settled to the supplier after completion',
  '无':'none',
  '有':'have',
  '请先登录':'please log in',
  '是否协调订单':'Whether to coordinate orders',
  '是':'yes',
  '否':'no',
  "最近7天":"Last 7 days",
  "最近30天":"Last 30 days",
  "等待需求方付款":"Waiting for payment from the demand side",
  "等待供应方选择协调服务":"Waiting for the supplier to choose coordination services",
  "待协调方接单":"Waiting for the coordinating party to accept the order",
  "等待供应方发货":"Waiting for the supplier to ship",
  "待协调方收货":"Waiting for the coordinating party to receive the goods",
  "协调方已收货":"The coordinating party has received the goods",
  "待收货":"Pending receipt of goods",
  "等待需求方评价":"Waiting for evaluation from the demand side",
  "请线下银行卡转账成功后等待丝迈官方确认收款":"Please wait for official confirmation of payment from Silmai after successful offline bank card transfer",
  "订单创建成功，请等待供应方更改价格，如价格无变动，则等待平台确认商品金额到账":"If the order is successfully created, please wait for the supplier to change the price, if the price does not change, wait for the platform to confirm that the product amount has arrived",
  "确认关闭订单":"Confirm to close the order",
  "添加下一页":"Add next page",
  "管理店铺": "Manage the store",
  "立即购买": "BUY NOW",
  "上一页": "Previous page",
  "售价不能为空": "The selling price cannot be empty",
  "原价不能为空": "The original price cannot be empty",
  "库存不能为空": "Inventory cannot be empty",
  "SKU编码不能为空": "SKU code cannot be empty",
  "存在重复的SKU编码": "There are duplicate SKU codes present",
  "丝迈交易平台管理端": "Simai Trading Platform Management End",
  "远程登录": "Remote Login",
  "账号权限验证": "Account Permission Verification",
  "验证": "Verify",
  "申请访问": "Request Access",
  "申请成功，请耐心等待审核": "Application submitted successfully. Please wait patiently for review.",
  "只能上传PNG格式的图片": "Only PNG format images can be uploaded",
  "所在页面": "Current page",
  "x坐标": "X coordinate",
  "Y坐标": "Y coordinate",
  "查看评价": "View reviews",
  "官方": "Official",
  "配送": "Delivery",
  "全选": "Select all",
  "验收资料": "Acceptance data",
  "请选择发货地址": "Please select the shipping address",
  "协调方认证": "Coordination authentication",
  "协调方认证名称": "Coordinating party certification name",
  "供应方店铺名称": "Supplier's store nameSupplier's store name",
  "店铺": "shop",
  "闭店": "Close the store",
  "营业": "In business",
  "已打烊": "Closed",
  "新增": "newly added",
  "二级分类": "secondary classification",
  "二级分类名称": "Secondary classification name",
  "请输入二级分类名称": "Please enter the name of the secondary category",
  "请输入排序值": "Please enter the sorting value",
  "一级分类": "Primary classification",
  "一级分类名称": "First level classification name",
  "请输入一级分类名称": "Please enter the first level classification name",
  "商品标签": "Product label",
  "商品主图": "Product main image",
  "案例标签": "Case tags",
  "请至少选择一项": "Please select at least one option",
  "中国个人收款银行卡绑定": "Chinese personal payment bank card binding",
  "中国企业收款银行卡绑定": "Chinese enterprise payment bank card binding",
  "是否设为默认": "Set as default",
  "需求双方合同签订后，需要支付定金": "After both parties sign the contract, a deposit is required to be paid",
  "需求在招标阶段展示的金额，不是最终合同金额，可以填“面议”": "The amount required to be displayed during the bidding phase is not the final contract amount, and can be filled in as' negotiable '",
  "男": "male",
  "女": "female",
  "时间": "Time",
  // 下面需要翻译
  "需求方提供的需求总金额": "The total amount of demand provided by the demander",
  "需求方已选择协调服务": "The demander has chosen the coordination service",
  "拒绝这个报价": "Reject this offer",
  "收货时间": "Receipt time",
  "请输入备注": "Please enter a comment",
  "确认报价": "Confirm the quote",
  "确认合同": "Confirm the contract",
  "需求方合同金额报价": "Demand-side contract amount quotation",
  "确认合同金额": "Confirm the contract amount",
  "合同签章": "Contract Signature",
  "将合同签章拖到文件相应位置": "Drag the contract signature to the appropriate location in the document",
  "请先上传签章": "Please upload a signature first",
  "签章图片加载失败，请重新上传": "Failed to load signature image, please upload again",
  "签署失败，请稍后重试": "Signing failed, please try again later",
  "合计": "Total",
  "印章": "Seal",
  "请扫码支付": "Please scan the QR code to pay",
  "最新需求": "New demand",
  "状态": "State",
  "请补充必填项": "Please fill in the required fields",
  "请使用微信扫描二维码完成授权": "Please use WeChat to scan the QR code to complete the authorization",
  "请使用支付宝扫描二维码完成授权": "Please use Alipay to scan the QR code to complete the authorization",
  "微信扫码授权": "WeChat scan code authorization",
  "支付宝扫码授权": "Alipay scan code authorization",
  "支付宝暂不可用": "Alipay is not available at the moment",
  "请输入详情内容": "Please enter your details",
  "请输入电话号码": "Please enter a phone number",
  "为保障您的权益，您支付的定金将由迈丝官方保管，直至项目完成后再同尾款一起结算给供应方": "In order to protect your rights and interests, the deposit you pay will be kept by the official Mess until the completion of the project and then settled to the supplier together with the final payment",
  "您可以修改此价格来表达你的合作价格意向": "You can modify this price to express your interest in co-op pricing",
  "修改价格": "Modify the price",
}



// WEBPACK FOOTER //
// ./src/language/en.js